import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';
import { NavController } from 'ionic-angular/index';
import {UtilProvider} from "../../providers/util/util";
import {ChooseChatroomPage} from "../../pages/choose-chatroom/choose-chatroom";

/**
 * Generated class for the ChooseChatroomComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'choose-chatroom',
  templateUrl: 'choose-chatroom.html',
})
export class ChooseChatroomComponent implements AfterViewInit {
  @Input('choosed_task') task;
  @Input('disabledChatrooms') disabledChatrooms;
  @Input('showChild') showChild;
  @Output() changeHeight = new EventEmitter();

  constructor(private navCtrl: NavController,public util:UtilProvider) {}

  ngAfterViewInit() {
    this.changeHeight.emit(true);
  }

  editChatrooms() {
    this.util.myNav(this.navCtrl,ChooseChatroomPage, {
      chatroom_list: this.task.chatroom_list,
      client_list: this.task.client_list,
      disabled_chatrooms: this.disabledChatrooms,
      showChild: this.showChild,
      saveChatroom:(e, f) =>{
        this.task.chatroom_list = e;
        this.task.client_list = f;
      }
    });

  }
}



// WEBPACK FOOTER //
// ./src/components/choose-chatroom/choose-chatroom.ts